<!-- ! THIS COMPONENT IS DEPRECATED: It relies on the old app-grid system and is non-performant. Use app-data-field-group-values instead-->
<ng-container *ngFor="let field of getDataFieldByGroup()">
    <div class="app-grid margin-bottom-4">
        <div class="columns-2 xl-columns-5 xxl-columns-4">
            <label>{{ field.name | ucfirst }}:</label>
        </div>
        <div class="columns-7">
            <span [class.blur]="field.isEncrypted" [class.hasLinebreaks]="field.type === dataFieldTypes.longText">
                {{ getDataValueByDataField(field)?.displayValue | translate }}
            </span>
        </div>
    </div>
</ng-container>
